import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  type SxProps,
  type Theme,
  Typography,
} from '@mui/material';
import type { ReactNode } from 'react';

const DIALOG_PAPER_SX: SxProps<Theme> = {
  width: '40rem',
  maxWidth: '40rem',
};

interface ClientSegmentDialogShellProps {
  open: boolean;
  title: string;
  subtitle?: string;
  error?: string | null;
  actions: ReactNode;
  onClose: () => void;
  children: ReactNode;
}

export const ClientSegmentDialogShell = ({
  open,
  title,
  subtitle,
  error,
  actions,
  onClose,
  children,
}: ClientSegmentDialogShellProps) => (
  <Dialog open={open} onClose={onClose} PaperProps={{ sx: DIALOG_PAPER_SX }}>
    <DialogTitle sx={{ pb: 1 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Stack>
          <Typography variant="h6" component="span">
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Stack>
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
    </DialogTitle>
    <DialogContent dividers>
      <Box py={1}>
        {error ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        ) : null}
        {children}
      </Box>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between' }}>{actions}</DialogActions>
  </Dialog>
);
